var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forbidden-page"},[_c('i',{staticClass:"el-icon-lock"}),_c('h2',[_vm._v("无权限访问")]),_c('p',[_vm._v("当前账号没有访问该页面的权限。")]),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.$router.replace('/')}}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }